import {ReactNode} from 'react';

import {Renderer} from '../../../libs/shared/core/src/helpers/react/reactHelpers';
import {ChannelTypesEnum} from '../../../libs/shared/core/src/models/api/channelCommonTypes';
import {IconName} from '../../../libs/shared/ui/src/components/icon/icon';
import {contactsIntegrationFrameId} from '../../models/api/integrationModel';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';

/*
 * Constants.
 */

export const nonEmailChannelTypes = [
  ChannelTypesEnum.FACEBOOK,
  ChannelTypesEnum.TWILIO,
  ChannelTypesEnum.TWILIO_WHATSAPP,
  ChannelTypesEnum.TWITTER,
  ChannelTypesEnum.TWITTER_DM,
  ChannelTypesEnum.YALO_WHATSAPP,
  ChannelTypesEnum.FRONT_CHAT,
  ChannelTypesEnum.PORTAL,
];

export const defaultIntegrationFrameIds = [contactsIntegrationFrameId];

export enum StartGuideTaskInteractionsEnum {
  TOUR_INTRO = 'tour_intro',
  EXPLORE_DEMO_INBOX = 'explore_demo_inbox',
  ADD_TEAM_INBOX = 'add_team_inbox',
  EXPLORE_RULES = 'explore_rules',
  INVITE_TEAM = 'invite_team',
  DOWNLOAD_APP = 'download_app',
  ADD_WORK_EMAIL = 'add_work_email',
  ADD_TEAM_RESPONSES = 'add_team_responses',
  SPECIALIST_TALK = 'specialist_talk',
  ADD_SMS_CHAT = 'add_sms_chat',
  ANALYTICS_SETUP = 'analytics_setup',
  CONNECT_INTEGRATIONS = 'connect_integrations',
  ADD_TEAM_TAGS = 'add_team_tags',
  ATTEND_1ON1_TRAINING = 'attend_1on1_training',
  ATTEND_LIVE_TRAINING = 'attend_live_training',
  ACCESS_TEAM_INBOX = 'access_team_inbox',
  SEND_FIRST_EMAIL = 'send_first_email',
  MENTION_TEAMMATE = 'mention_teammate',
  EXPLORE_SETTINGS = 'explore_settings',
}

/*
 * Props.
 */

export interface StartGuideTaskDefinition {
  iconName: IconName;
  title: ReactNode;
  description: ReactNode;
  isIncomplete: boolean;
  onClick: () => void;
  interactionId: string;
  isDisabled?: boolean;
  renderTooltip?: Renderer;
  /** An optional info bubble to open on clicking this task. */
  infoBubble?: OnboardingTipTypesEnum;
}
